export default class OrdersEndpoint {
  constructor(api) {
    this.api = api;
  }

  createOrder(data) {
    return this.api.post('/orders', data);
  }

  createTochkaPayment(user_course_id) {
    return this.api.post('/orders/payment/tochka', { user_course_id });
  }

  verifyTochkaPayment(operation_id) {
    return this.api.post('/orders/payment/tochka/success', { operation_id });
  }

  getTochkaTransaction(operation_id) {
    return this.api.get(`/orders/payment/tochka/transactions/${operation_id}`);
  }
}
